import * as React from 'react';

import * as styles from './styles/segment.css';

interface ISegmentProps {
  children?: React.ReactNode;
}

export function Segment({ children }: ISegmentProps) {
  return <div className={styles['segment']}>{children}</div>;
}
